import { SlicesUIElement, html } from '../element/element';
import { StringConverter, NumberConverter } from 'html-element-property-mixins/src/utils/attribute-converters';
import { css } from './selector.css.js';

/**
 * 
 * @element slicesui-selector
 * 
 * @fires change - Fires when 'selectedIndex' value changed
 * 
 * @prop {Number} [selectedIndex=-1] - Index of selected item
 * @attr {Number} [selectedindex]
 * 
 * @prop {Number} [selectedAttribute='data-slices-selected'] - Boolean attribute to be used for selected element
 * @attr {Number} [selectedAttribute]
 * 
 * @prop {Boolean} [valueAttribute='value'] - Attribute used for selected item
 * @attr {Boolean} [valueAttribute]
 * 
 * @slot
 * 
 */
class SlicesUISelector extends SlicesUIElement {

  static get properties() {
    return {
      
      selectedIndex: {
        observe: true,
        DOM: true,
        reflect: true,
        fromAttributeConverter: NumberConverter.fromAttribute,
        toAttributeConverter: NumberConverter.toAttribute,
        changedHandler: '_selectedIndexChanged'
      },

      selectedAttribute: {
        observe: true,
        DOM: true,
        fromAttributeConverter: StringConverter.fromAttribute,
      },

      valueAttribute: {
        observe: true,
        DOM: true,
        fromAttributeConverter: StringConverter.fromAttribute,
      },
      
      _assignedElements: {
        observe: true
      }

    };
  }

  static get propertiesChangedHandlers() {
    return {
      _updateDOM: ['selectedIndex', 'selectedAttribute', 'valueAttribute', '_assignedElements'],
      render: ['selectedIndex', 'selectedAttribute', 'valueAttribute', '_assignedElements']
    };
  }

  constructor() {
    super();
    this._assignedElements = [];
    this.valueAttribute = 'value';
    this.selectedAttribute = 'data-slices-selected';
    this.selectedIndex = -1;
    this.addEventListener('click', this._handleClick.bind(this));
  }

  /**
   * @private
   */
  get template() {
    return html`
      <style>${css}</style>
      <slot @slotchange="${this._handleSlotChange}"></slot>
    `;
  }
  
  /**
   * @private
   */
  get value() {
    const item = this.querySelector(`[${this.selectedAttribute}]`);
    if(!item) return null;
    return item.getAttribute(this.valueAttribute);
  }

  set selectedIndex(val) {
    this['#selectedIndex'] = parseInt(val);
  }

  _updateDOM() {
    if(!this._assignedElements) return;
    const oldItems = this.querySelectorAll(`[${this.selectedAttribute}]`);
    const newItem = this._assignedElements[this.selectedIndex];
    if(oldItems) oldItems.forEach(item => item.removeAttribute(this.selectedAttribute));
    if(newItem) newItem.setAttribute(this.selectedAttribute, '');
    this._dispatchChangeEvent();
  }

  _handleSlotChange(e) {
    const assignedElements = Array.from(e.target.assignedNodes()).filter(item => item.nodeName !== '#text');
    this._assignedElements = [...assignedElements];
    this._updateDOM();
  }

  _handleClick(e) {
    const index = this._assignedElements.indexOf(e.target);
    if(index === -1) return;
    this.selectedIndex = index;
  }

  _dispatchChangeEvent() {
    const evt = new CustomEvent('change', { detail: {value: this.value} });
    this.dispatchEvent(evt);
  }

}

window.customElements.define('slicesui-selector', SlicesUISelector);